/**
 * Renders the Soup Building Activity app on the DOM.
 * @function
 * @param {string} resourceURI - The base URI where the app will load its resources from (images, data, videos, etc.)
 * @returns {void}
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';


const rootElement = document.getElementById('soup-building-activity');
const root = ReactDOM.createRoot(rootElement);

const resourceURI = rootElement.getAttribute('data-resource-uri');

root.render(
  <MemoryRouter>
    <App resourceURI={resourceURI} />
  </MemoryRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();